import React from "react";
const pptIcon = ({ styles, ...rest }) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42", ...rest }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    className: styles.file_upload_icon_background,
    d: "M0 0H4823V3877H0z",
    transform: "translate(-1535 -3613)"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M1535 3613H1575V3655H1535z", transform: "translate(-1535 -3613)" }), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    className: styles.file_upload_icon_background,
    d: "M13.6 0.9L7.9 8.3 4.9 4.7 0.5 9.9 6.7 9.9 9.2 9.9 20.5 9.9z",
    transform: "translate(-1535 -3613) translate(1535 3613) translate(9 21)"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    className: styles.file_upload_icon_background,
    fillRule: "nonzero",
    d: "M3.3 11.5L0.6 11.5 4.2 5.9 0.8 0.6 3.5 0.6 5.5 4.1 7.5 0.6 10.2 0.6 6.8 5.9 10.4 11.5 7.6 11.5 5.5 7.8z",
    transform: "translate(-1535 -3613) translate(1535 3613) translate(14 19)"
  }
), /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel", strokeWidth: "1.003" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M35.5 41.5L3.5 41.5 3.5 0.5 23 0.5 35.5 13.3z",
    transform: "translate(-1535 -3613) translate(1535 3613)"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M22.6 13.4L35.5 13.3 34.9 12.7 23.6 1.1 23 0.5z",
    transform: "translate(-1535 -3613) translate(1535 3613)"
  }
)), /* @__PURE__ */ React.createElement(
  "path",
  {
    className: styles.file_upload_icon_background,
    fillRule: "nonzero",
    d: "M21.4 23.2c0-.6-.2-1-.5-1.2-.3-.2-.7-.4-1.3-.4h-2.1v3.2h2.1c.5 0 1-.1 1.3-.4.4-.3.5-.7.5-1.2zm2.3-.1c0 1.3-.3 2.2-1 2.8-.7.5-1.6.8-2.8.8h-2.3v4h-2.3v-11h4.8c1.1 0 2 .3 2.6.9.7.5 1 1.4 1 2.5z",
    transform: "translate(-1535 -3613) translate(1535 3613)"
  }
))));
var pptIcon_default = pptIcon;
export {
  pptIcon_default as default
};
//# sourceMappingURL=pptIcon.js.map
